import styled from 'styled-components';
import { TREE_VERTICAL_DASH_OFFSET, TREE_DRAG_ANIM_TIME, TREE_DRAG_ANIM_CURVE } from '../../constants.js';

var TreeNodeHorizontalDashes = styled.div.withConfig({
  displayName: "HorizontalDashes__TreeNodeHorizontalDashes",
  componentId: "sc-j2z392-0"
})(function (_ref) {
  var isDragOverBottomBar = _ref.isDragOverBottomBar,
    isDragOverTopBar = _ref.isDragOverTopBar,
    theme = _ref.theme;
  var top = "50%";
  if (isDragOverTopBar) {
    top = "75%";
  } else if (isDragOverBottomBar) {
    top = "25%";
  }
  return {
    position: "absolute",
    top: top,
    left: "".concat(TREE_VERTICAL_DASH_OFFSET, "px"),
    right: 0,
    transform: "translateY(-".concat(top, ")"),
    borderTop: "1px dashed ".concat(theme.neutralColors.silver),
    transition: "all ".concat(TREE_DRAG_ANIM_TIME, " ").concat(TREE_DRAG_ANIM_CURVE)
  };
});

export { TreeNodeHorizontalDashes };
